var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackToTop)?_c('div',{staticClass:"toTop",on:{"click":_vm.scrollToTop}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }